import { render } from "./SalaryPanel.vue?vue&type=template&id=303ae658"
import script from "./SalaryPanel.vue?vue&type=script&lang=js"
export * from "./SalaryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__